import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        login(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.user.role === "admin" ? "/admin" : "/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        toast.error(formatApiError(e, "Google sign-in failed"));
        window.history.replaceState(null, "", "/login");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B132B]" data-testid="auth-callback">
      <Loader2 className="h-8 w-8 text-[#FF6B00] animate-spin" />
    </div>
  );
};
